var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewAccept(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70611 13C8.56583 12.64 8.36543 12.16 8.12495 11.56C7.88447 10.96 7.56383 10.2 7.16303 9.32C6.96263 8.88 6.74219 8.38 6.5017 7.86L6.36142 7.56H2.93457L8.54579 20L18.0648 0L8.70611 13Z",
    fill: "url(#paint0_linear_6409_85028)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6409_85028",
    x1: 10.5096,
    y1: 19.9669,
    x2: 10.5096,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65933F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    stopColor: "#BAD532"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewAccept);
export default __webpack_public_path__ + "static/media/ReviewAccept.8c241c27ae3bbef402a78e44d68d3399.svg";
export { ForwardRef as ReactComponent };